import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://breakthroughpropertymanagement.com";
const DEFAULT_TITLE = "Breakthrough Real Estate & Property Management | Phoenix, Arizona";
const DEFAULT_DESCRIPTION =
  "Phoenix and Maricopa County property management, brokerage, rental analysis, investment guidance, owner resources and resident support.";

const META = {
  "/": {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  },
  "/property-management": {
    title: "Phoenix Property Management | Breakthrough Real Estate & Property Management",
    description:
      "Phoenix and Maricopa County property management focused on rent positioning, vacancy reduction, maintenance coordination, resident service and owner visibility.",
  },
  "/insights": {
    title: "Phoenix Real Estate Market Insights | BREPM",
    description:
      "Phoenix housing, rental and investment real estate insights for owners, landlords and investors across Maricopa County, Arizona.",
  },
  "/investing": {
    title: "Phoenix Real Estate Investing, Buying & Selling | BREPM",
    description:
      "Phoenix real estate brokerage and investment guidance for rental property owners, buyers, sellers and multifamily investors in Maricopa County.",
  },
  "/resources": {
    title: "Property Owner & Resident Resources | BREPM Phoenix",
    description:
      "Useful resources for Phoenix rental property owners, residents and real estate investors from Breakthrough Real Estate & Property Management.",
  },
};

function upsertMeta(selector, attribute, value) {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement("meta");
    const match = selector.match(/meta\[(name|property)="([^"]+)"\]/);
    if (match) node.setAttribute(match[1], match[2]);
    document.head.appendChild(node);
  }
  node.setAttribute(attribute, value);
}

export default function SeoManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const articlePath = pathname.startsWith("/insights/");
    const page = META[pathname] || (articlePath ? META["/insights"] : META["/"]);
    const canonicalUrl = `${SITE}${pathname === "/" ? "/" : pathname.replace(/\/$/, "")}`;

    document.title = page.title;
    upsertMeta('meta[name="description"]', "content", page.description);
    upsertMeta('meta[property="og:title"]', "content", page.title);
    upsertMeta('meta[property="og:description"]', "content", page.description);
    upsertMeta('meta[property="og:url"]', "content", canonicalUrl);
    upsertMeta('meta[name="twitter:title"]', "content", page.title);
    upsertMeta('meta[name="twitter:description"]', "content", page.description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);
  }, [pathname]);

  return null;
}
